import axios from 'axios';
import makeApiRoute from '../utils/apiRoute';

export class ConfigurationService {

   public static getConfiguration(apiKey: string) {
      return axios.get(makeApiRoute(`/configuration/${apiKey}/public`), {
         headers: {
            Accept: 'application/json'
         }
      });
   }
}
